<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-05 15:26:20
 * @Description: 安全问题
-->
<template>
	<div>
		<Head :title="$t('home.account_set.question')" />

		<a-form-model :model="form" ref="form">
			<a-row :gutter="16" style="padding-right: 4.16%">
				<template v-for="(item, index) in form.questionVos">
					<a-col :span="12" :key="`qus${index}`">
						<a-form-model-item
							:label="`${$t('base.question.label')}${index + 1}`"
							:label-col="{ span: 6 }"
							:wrapper-col="{ span: 18 }"
							:prop="'questionVos.' + index + '.question'"
						>
							<a-select v-model="item.question" :placeholder="$t('base.question.question_placeholder')" allowClear>
								<a-select-option v-for="qus in qusArr2" :value="qus.id" :key="qus.id" :disabled="qus.disabled">
									{{ qus.question }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="12" :key="`ans${index}`">
						<a-form-model-item
							:label="`${$t('base.question.answer')}${index + 1}`"
							:label-col="{ span: 6 }"
							:wrapper-col="{ span: 18 }"
							:prop="'questionVos.' + index + '.answer'"
						>
							<a-input v-model="item.answer" :placeholder="$t('base.question.placeholder')" allowClear></a-input>
						</a-form-model-item>
					</a-col>
				</template>
			</a-row>
		</a-form-model>
	</div>
</template>

<script>
import Head from "./components/Head";
import { commonAPI } from "@/apis";
import { mapGetters } from "vuex";

export default {
	components: { Head },
	props: {
		selfQus: { type: Array, default: [] },
	},
	data() {
		return {
			qusArr: [],
			form: {
				questionVos: [
					{ question: undefined, answer: "" },
					{ question: undefined, answer: "" },
					{ question: undefined, answer: "" },
				],
			},
		};
	},
	computed: {
		...mapGetters("auth", ["user"]),
		qusArr2() {
			let arr = this.qusArr;
			arr.forEach((el) => {
				let item = this.form.questionVos.find((o) => o.question == el.id);
				el.disabled = item ? true : false;
			});
			return arr;
		},
	},
	created() {
		this.getDefaultInfo();
	},
	mounted() {
		this.selfQus.forEach((el, index) => {
			this.form.questionVos[index].question = el.id || undefined;
			this.form.questionVos[index].answer = el.answer || "";
		});
	},
	methods: {
		// 获取默认密保
		async getDefaultInfo() {
			const { code, data } = await commonAPI.getAction("/user/password/question/getAll");
			if (code == 0) {
				this.qusArr = data || [];
			}
		},
		// 获取自己的密保问题
		async getSelfInfo() {
			const { code, data } = await commonAPI.getAction(`/users/getPwdQuestionAndAnswerByUser/${this.user.username}`);
			if (code == 0) {
				let arr = data || [];
			}
		},
	},
};
</script>

<style scoped lang="less">
.question {
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	& > div {
		&:last-child {
			margin-left: 60px;
		}
		flex: 1;
		display: flex;
		align-items: center;
		& > div:last-child {
			flex: 1;
			margin-left: 20px;
		}
	}
}
</style>
